import { Box, styled } from '@mui/material';
import { Panel } from 'components/mrp/mrp.styles';
import { ContextPanelSize } from './ContextPanel.types';

export const StyledContextPanel = styled(Panel, {
  shouldForwardProp: (prop: string) => !['width'].includes(prop)
})(({ theme, width }) => ({
  minWidth: `${width}px`,
  height: width === ContextPanelSize.COMPACT ? 'fit-content' : '100%',
  width: 'initial',
  backgroundColor: width === ContextPanelSize.COMPACT ? 'inherit' : 'white',
  ...(width === ContextPanelSize.COMPACT && {
    '> *[role="menubar"]': {
      '*[role="heading"]': {
        display: 'none'
      }
    },
    '> *[role="tabpanel"]': {
      display: 'none'
    },
    '> *[role="navigation"]': {
      flexDirection: 'column'
    }
  }),
  transition: `${theme.transitions.duration.short}ms`
}));

export const StyledNavigation = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  transitionDuration: `${theme.transitions.duration.shortest}ms`
}));

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100% - 70px)',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  transitionDuration: `${theme.transitions.duration.shortest}ms`
}));

export const ToggleButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive: boolean | undefined }>(({ theme, isActive }) => ({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '60px',
  width: '100%',
  padding: theme.spacing(0, 1),
  backgroundColor: 'transparent',
  borderRadius: theme.shape.borderRadius,
  border: 'none',
  boxShadow: 'none',
  cursor: 'pointer',
  color: `${
    isActive ? theme.vars.palette.primary.onFixed : theme.palette.text.primary
  }`,
  transitionDuration: `${theme.transitions.duration.shortest}ms`,

  '&:hover': {
    backgroundColor: isActive ? 'initial' : theme.vars.palette.action.hover
  }
}));

export const ToggleButtonHoverPane = styled(Box, {
  shouldForwardProp: (prop: string) => !['panelSize'].includes(prop)
})<{
  length: number;
  index: number;
  panelSize: ContextPanelSize;
}>(({ theme, length = 1, index = 0, panelSize }) => ({
  position: 'absolute',
  height:
    panelSize === ContextPanelSize.COMPACT
      ? `calc(calc(100% - ${theme.spacing(2 * length)}) / ${length})`
      : '60px',
  width:
    panelSize === ContextPanelSize.COMPACT ? '100%' : `calc(100% / ${length})`,
  backgroundColor: theme.vars.palette.secondary.container,
  borderRadius: 16,
  transform:
    panelSize === ContextPanelSize.COMPACT
      ? `translateY(calc(${index} * calc(100% + ${theme.spacing(2.1)})))`
      : `translateX(calc(${index} * 100%))`,
  transitionDuration: `${theme.transitions.duration.shortest}ms`
}));
